import { z } from 'zod';
import { userRoleSchema } from '@/entities/user/model/userSchema';

export const UserSchema = z.object({
  id: z.string(),
  display_name: z.string(),
  email: z.string().nullish(),
  role: userRoleSchema,
  /** Связанная запись employees (1:1 для штатных учёток). */
  employee_id: z.string().uuid().nullable().optional(),
});

export const CurrentUserSchema = z.object({
  user: UserSchema,
});

export type User = z.infer<typeof UserSchema>;
export type UserApi = z.input<typeof UserSchema>;
